import { render, staticRenderFns } from "./product-files-show.vue?vue&type=template&id=281041ca"
import script from "./product-files-show.vue?vue&type=script&lang=js"
export * from "./product-files-show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports